export enum SingpassEvents {
  SINGPASS_AUTHORIZATION = 'singpass_authorization',
}
